import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideCircleCheckBig = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M21.801 10A10 10 0 1 1 17 3.335" />
      <path d="m9 11 3 3L22 4" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideCircleCheckBig);
const Memo = memo(ForwardRef);
export default Memo;
